// icon
import { IconShoppingBag } from "@tabler/icons-react";
// link
import { Link } from "react-router";
// splitnumber
import { splitNumber } from "../../features/splitNumber/splitNumber";

const NewProducts = (props: any) => {
    return (
        <>
            <div data-aos="fade-right"
                className="card new-product-card shadow border-0 rounded-4">
                <div className="card-image rounded rounded-4 p-3">
                    <div className="d-flex justify-content-center align-items-center">
                        <Link to={`/items/detail/${props.slug}`} className="text-decoration-none">
                            <img src={props.primary_image} alt="product" />
                        </Link>
                    </div>
                </div>
                <div className="card-body">
                    <Link to={`/items/detail/${props.slug}`} className="text-decoration-none">
                        <div className="d-flex w-100 justify-content-between align-items-center" style={{ height: '45px' }}>
                            <h6 className="text-dark fw-bold text-split font-medium-lg mb-0">
                                {props.name}
                            </h6>
                        </div>
                        <hr style={{ marginTop: '5px' }} />
                        <div className="d-flex gap-2 w-100 align-items-center justify-content-between">
                            <div className="text-center w-100">
                                <button className="btn btn-outline-primary w-100">
                                    {props?.has_variation !== 0 ? (
                                        <>
                                            {props.quantity_check?.price ? (
                                                <span className="price font-medium fw-bold mt-3">{splitNumber(props.quantity_check?.price)}  تومان</span>
                                            ) : (
                                                <span className="text-danger fw-bold price font-medium mt-3">نا موجود</span>
                                            )}
                                        </>
                                    )
                                        :
                                        (
                                            <>
                                                {props.count !== 0 ? (
                                                    <span className="price fw-bold font-medium mt-3">{splitNumber(props.price)}  تومان</span>
                                                ) : (
                                                    <span className="text-danger fw-bold price font-medium mt-3">نا موجود</span>
                                                )}
                                            </>
                                        )
                                    }
                                </button>
                            </div>
                            <Link to={`/items/detail/${props.slug}`} className="btn btn-outline-primary py-1 px-2 w-25">
                                <IconShoppingBag size={16} />
                            </Link>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default NewProducts;